const Resources = () => {
  return (
    <div className="Pages">
    <h1>Resources</h1>
    <i>Oberman Financial Coaching is not affiliated with nor is compensated with these organizations and products.</i>
    <p><b>Publications</b></p>
    <a href=" https://www.kiplinger.com/">Kiplinger Personal Finance</a>
   
    <p><b>Tools</b></p>
    <a href=" https://www.quicken.com/">Quicken Personal Finance Software</a><br></br>
    <a href=" https://www.creditkarma.com/">Credit Karma</a>

    <p><b>Podcasts</b></p>
    <a href="https://www.stackingbenjamins.com/">The Stacking Benjamins Podcast</a>
  </div>
  );
};

export default Resources;
